import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import setRouteWithForcedRefresh from 'flarum/common/utils/setRouteWithForcedRefresh';
import extractText from 'flarum/common/utils/extractText';
import { discussionTypeOptions } from './discussionTypeOptions';
const INDEX_PAGE = 'flarum/forum/components/IndexPage';

// The "all types" option is the absence of a filter, not a value the backend
// knows, so it carries no type string of its own.
const ALL_TYPES = null;

// The type currently in the URL, or ALL_TYPES when the list is unfiltered.
function activeType() {
  var _app$search$state$par, _app$search$state$par2;
  return (_app$search$state$par = (_app$search$state$par2 = app.search.state.params().filter) == null ? void 0 : _app$search$state$par2.discussionType) != null ? _app$search$state$par : ALL_TYPES;
}

// Drives the route rather than component state: `GlobalSearchState.stickyParams()`
// reads `filter` straight off the mithril route and `IndexPage` hands it to the
// discussion list, so a filtered list is an address that survives a reload, a
// share and the back button. Mutating `app.discussions.params` would not.
function selectType(type) {
  const params = app.search.state.params();
  const filter = _objectSpread({}, params.filter);
  if (type === ALL_TYPES) {
    // Deleted rather than emptied, so the unfiltered list keeps its bare URL.
    delete filter.discussionType;
  } else {
    filter.discussionType = type;
  }
  setRouteWithForcedRefresh(app.route(app.current.get('routeName'), _objectSpread(_objectSpread({}, params), {}, {
    filter
  })));
}
app.initializers.add('bhic-discussion-type-filter', () => {
  extend(INDEX_PAGE, 'viewItems', function (items) {
    var _options$active;
    // Cosmetic only. DefaultTypeClamp is what restricts the list; a
    // hand-written filter URL returns an empty list for an actor without the
    // permission rather than a forbidden response.
    if (!app.forum.attribute('canViewAllDiscussionTypesInList')) return;
    const options = _objectSpread({
      [ALL_TYPES]: extractText(app.translator.trans('bhic.forum.discussion_type_filter.all'))
    }, discussionTypeOptions());
    const active = activeType();
    items.add('bhicDiscussionType', m(Dropdown, {
      buttonClassName: "Button",
      label: (_options$active = options[active]) != null ? _options$active : options[ALL_TYPES],
      accessibleToggleLabel: extractText(app.translator.trans('bhic.forum.discussion_type_filter.label'))
    }, Object.keys(options).map(value => {
      // Object keys are strings, so the "all types" key arrives back as
      // 'null' and has to be mapped to the value the route understands.
      const type = value === String(ALL_TYPES) ? ALL_TYPES : value;
      const isActive = type === active;
      return m(Button, {
        icon: isActive ? 'fas fa-check' : true,
        onclick: () => selectType(type),
        active: isActive
      }, options[value]);
    })), -10);
  });
});